var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNanonets(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.7524 5.96881C10.2901 5.96881 11.5367 4.72222 11.5367 3.18448C11.5367 1.64673 10.2901 0.400146 8.7524 0.400146C7.21466 0.400146 5.96807 1.64673 5.96807 3.18448C5.96807 4.72222 7.21466 5.96881 8.7524 5.96881Z",
    fill: "#546FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.96807 14.3218C7.50582 14.3218 8.7524 13.0752 8.7524 11.5375C8.7524 9.99972 7.50582 8.75313 5.96807 8.75313C4.43033 8.75313 3.18374 9.99972 3.18374 11.5375C3.18374 13.0752 4.43033 14.3218 5.96807 14.3218Z",
    fill: "#546FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.18374 22.6748C4.72149 22.6748 5.96807 21.4282 5.96807 19.8905C5.96807 18.3527 4.72149 17.1061 3.18374 17.1061C1.646 17.1061 0.399414 18.3527 0.399414 19.8905C0.399414 21.4282 1.646 22.6748 3.18374 22.6748Z",
    fill: "#546FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8897 5.96881C21.4275 5.96881 22.674 4.72222 22.674 3.18448C22.674 1.64673 21.4275 0.400146 19.8897 0.400146C18.352 0.400146 17.1054 1.64673 17.1054 3.18448C17.1054 4.72222 18.352 5.96881 19.8897 5.96881Z",
    fill: "#546FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1054 14.3218C18.6431 14.3218 19.8897 13.0752 19.8897 11.5375C19.8897 9.99972 18.6431 8.75313 17.1054 8.75313C15.5676 8.75313 14.3211 9.99972 14.3211 11.5375C14.3211 13.0752 15.5676 14.3218 17.1054 14.3218Z",
    fill: "#546FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3211 22.6748C15.8588 22.6748 17.1054 21.4282 17.1054 19.8905C17.1054 18.3527 15.8588 17.1061 14.3211 17.1061C12.7833 17.1061 11.5367 18.3527 11.5367 19.8905C11.5367 21.4282 12.7833 22.6748 14.3211 22.6748Z",
    fill: "#546FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.03091 2.34917C8.56685 2.16355 8.10273 2.44202 7.91711 2.90607L6.52494 7.08257C6.33932 7.54662 6.61773 8.01069 7.08178 8.19631C7.54584 8.38193 8.00996 8.10347 8.19558 7.63941L9.58775 3.46292C9.77337 2.99886 9.49496 2.5348 9.03091 2.34917Z",
    fill: "#546FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9917 14.7859C15.5277 14.6003 15.0636 14.8787 14.8779 15.3427L13.4858 19.5192C13.3001 19.9833 13.5786 20.4473 14.0426 20.633C14.5067 20.8186 14.9708 20.5402 15.1564 20.0761L16.5486 15.8996C16.7342 15.4356 16.4558 14.9715 15.9917 14.7859Z",
    fill: "#546FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.13278 11.2591C5.3184 10.795 5.78252 10.5165 6.24658 10.7022C6.71063 10.8878 6.98904 11.3519 6.80342 11.8159L4.01909 20.1689C3.83347 20.6329 3.36935 20.9114 2.90529 20.7258C2.44124 20.5402 2.16282 20.0761 2.34845 19.6121L5.13278 11.2591Z",
    fill: "#546FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0544 2.90607C19.24 2.44202 19.7042 2.16355 20.1682 2.34917C20.6323 2.5348 20.9107 2.99886 20.7251 3.46292L17.9407 11.8159C17.7551 12.28 17.291 12.5584 16.8269 12.3728C16.3629 12.1872 16.0845 11.7231 16.2701 11.2591L19.0544 2.90607Z",
    fill: "#546FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.40199 2.5348C9.03074 2.16356 8.47395 2.16356 8.19551 2.5348C7.82427 2.90604 7.82427 3.4629 8.19551 3.74133L16.5485 12.0943C16.9197 12.4656 17.4765 12.4656 17.755 12.0943C18.1262 11.7231 18.1262 11.1662 17.755 10.8878L9.40199 2.5348Z",
    fill: "#546FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.61766 10.8878C6.24642 10.5165 5.68962 10.5165 5.41118 10.8878C5.03994 11.259 5.03994 11.8159 5.41118 12.0943L13.7642 20.4473C14.1354 20.8186 14.6922 20.8186 14.9706 20.4473C15.3419 20.0761 15.3419 19.5192 14.9706 19.2408L6.61766 10.8878Z",
    fill: "#546FFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.5217,
    height: 22.5217,
    fill: "white",
    transform: "translate(0.399414 0.400146)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNanonets);
export default __webpack_public_path__ + "static/media/nanonets.50fdbf0e35ce9d02815696e3170c0132.svg";
export { ForwardRef as ReactComponent };